import { type Common } from '../common.js';
import {
  type StandardAnalyticEvent,
  type StandardAnalyticEventFindAllParams,
} from '../models/flow/standardAnalyticEvent.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/standard-analytic-events';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    queryParams?: StandardAnalyticEventFindAllParams
  ): Promise<StandardAnalyticEvent[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<StandardAnalyticEvent> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async create(
    values: Omit<StandardAnalyticEvent, 'id' | 'created' | 'updated'>
  ): Promise<StandardAnalyticEvent> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(
    id: string,
    values: Partial<Omit<StandardAnalyticEvent, 'id' | 'created' | 'updated'>>
  ): Promise<StandardAnalyticEvent> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.putJSON(url, values);
  }

  async remove(id: string): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    await this.common.deleteJSON(url);
  }
}
